// Same breakpoint as MobileOnly
const MOBILE_CHECKOUT_QUERY = '(max-width: 767px)';

export default MOBILE_CHECKOUT_QUERY;
